import style from "./documentcard.module.css";
import { RxCross1 } from "react-icons/rx";
import Tooltip from "../../../../Components/Tooltip/Tooltip";
import Toggle from "../../../../Components/Common/Toggle";
import { DocApi } from "../../../../App/api/document.apis";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { toast } from "react-toastify";
import SelectDropdown from "../../../../Components/Dropdown/SelectDropdown";

function DocumentModel({
  isdocModel,
  fetchAllData,
  handlecloseDocModel,
  editData,
  userRoleData,
}) {
  const initialValues = {
    _id: editData?._id || "",
    name: editData?.name || "",
    userRole: editData?.userRole?._id || [],
    is_mandatory: editData?.is_mandatory || false,
    is_visible: editData?.is_visible || false,
    is_expiry_date: editData?.is_expiry_date || false,
    is_unique_code: editData?.is_unique_code || false,
  };

  if (editData) {
    // console.log("userRole", editData.userRole.name);
  }

  const handleSubmit = async (values, resetForm) => {
    // console.log("on click data: ", values);

    const data ={...values,user_role:values?.userRole?._id}

    try {
      const createRes = editData
        ? await DocApi.updateDocument(values, initialValues._id)
        : await DocApi.createDocument(data);
      // console.log("create response: ", createRes.data?.data);
      toast.success(
        initialValues._id ? "Document Updated" : "Document Created"
      );
      fetchAllData();
    } catch (err) {
      // console.log(err);
      toast.error(err?.message);
    } finally {
      // resetForm();
      handlecloseDocModel();
    }
  };

  if (isdocModel) {
    return (
      <div className={style.main_bg}>
        <Formik
          initialValues={initialValues}
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, handleChange, values }) => (
            <Form className={style.container_model}>
              <div className={style.header_div}>
                <span style={{ fontSize: "1.4rem", color: "purple" }}>
                  {editData !== "" ? "Edit Document" : "Add New Document"}
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handlecloseDocModel()}
                >
                  <RxCross1 />
                </span>
              </div>
              <div className={style.inputs}>
                {/* Document Name Field */}
                <div>
                  <div className="d-flex">
                    <p htmlFor="">Document Name</p>
                    <Tooltip text="Enter Document Name" size={"12"} />
                  </div>
                  <Field
                    placeholder="Enter Document Name"
                    type="text"
                    onChange={(e) => setFieldValue("name", e.target.value)}
                    className={style.input_field}
                    name="name"
                    value={values.name}
                  />
                  <ErrorMessage name="name" component="div" className="error" />
                </div>

                <SelectDropdown
                  value={values?.userRole?.name}
                  inputName="userRole"
                  placeholder={
                    editData ? editData?.userRole?.name : "Select Type"
                  }
                  options={userRoleData}
                  handleFilter={(inputName, v) => {
                    setFieldValue(`${inputName}`, v);
                  }}
                />

                {/* Document Toggles Field */}
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      marginTop: "1.4rem",
                    }}
                  >
                    <Toggle
                      value={values.is_mandatory}
                      onChange={() =>
                        setFieldValue("is_mandatory", !values.is_mandatory)
                      }
                    />
                    <p>Is this document mandatory ?</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      marginTop: "1.4rem",
                    }}
                  >
                    <Toggle
                      value={values.is_visible}
                      onChange={() =>
                        setFieldValue("is_visible", !values.is_visible)
                      }
                    />
                    <p>Document visible ?</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      marginTop: "1.4rem",
                    }}
                  >
                    <Toggle
                      value={values.is_expiry_date}
                      onChange={() =>
                        setFieldValue("is_expiry_date", !values.is_expiry_date)
                      }
                    />
                    <p>Is document have expiry date ?</p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      marginTop: "1.4rem",
                    }}
                  >
                    <Toggle
                      value={values.is_unique_code}
                      onChange={() =>
                        setFieldValue("is_unique_code", !values.is_unique_code)
                      }
                    />
                    <p>Is document have unique code ?</p>
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "1rem",
                  marginTop: "1.4rem",
                }}
              >
                <button type="submit" className="btn">
                  {editData ? "Update" : "Submit"}
                </button>
                <button
                  type="button"
                  className="btn_border"
                  onClick={() => handlecloseDocModel()}
                >
                  Cancel
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default DocumentModel;
